import { FormControl, FormHelperText } from '@mui/material';
import type { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { RaLabel } from '@modules/_shared/components/form/RaLabel';
import { OrganisationSelect } from '@modules/_shared/components/organisation-select/OrganisationSelect';

export type RaOrganisationProps = {
  errors: any;
  getValues: UseFormGetValues<any>;
  setValue: UseFormSetValue<any>;
  name: string;
  label: string;
};

export const RaOrganisation = ({
  getValues,
  setValue,
  errors,
  name,
  label,
}: RaOrganisationProps) => {
  const organisationId = getValues(name);
  return (
    <FormControl fullWidth error={!!errors[name]}>
      <RaLabel label={label} />
      <OrganisationSelect
        organisationId={organisationId}
        onChange={organisationId =>
          setValue(name, organisationId, { shouldDirty: true })
        }
      />
      {errors[name]?.message && (
        <FormHelperText>{errors[name].message}</FormHelperText>
      )}
    </FormControl>
  );
};
